import React, {
  useState,
  useReducer,
  useCallback,
  useEffect,
  useContext
} from 'react';
import useSkipUpdate from '../../hooks/useSkipRender';
import StatusBasedSchedulerGeneratorView from '../view/StatusBasedSchedulerGeneratorView';
import { AutomationsContex } from './FormBuilderAutomationsEngine';
// import { FormBuilderContext } from './FormBuilderEngine';

const defualtState = {
  condition: {
    conditionType: 'status',
    interval: 30,
    intervalUnit: 'day',
    statusList: [],
    dateOperator: 'after'
  }
};

const TimeBasedReducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case 'update':
      return { ...state, ...payload };

    case 'update_condition':
      return {
        ...state,
        condition: { ...(state.condition || {}), ...payload }
      };
    default:
      return state;
  }
};

/**
 *
 * @param {Object} schedule - Object that holds data for the view to use (format = mock object at the top)
 * @param {Function} update - A function to get the updated dataBlock
 */
const StatusBasedSchedulerGeneratorEngine = ({
  schedule = defualtState,
  update = dBlock => dBlock,
  form: givenForm
}) => {
  const [data, dispatch] = useReducer(TimeBasedReducer, schedule);
  const { shouldSkipUpdate, skipUpdate } = useSkipUpdate(false);
  const automationContext = useContext(AutomationsContex);
  const form = givenForm || automationContext.form;
  
  const [statusesDD, setStatusesDD] = useState([]);

  useEffect(() => {
    if (shouldSkipUpdate()) {
      return;
    }
    update(data);
  }, [data]);

  useEffect(() => {
    // const isAnonymous = form.sharingType === 'anonymous'; // TODO: handle this, hide invalid options
    let newStatusesDD = [];
    if (form && form.customStatuses) {
      newStatusesDD = form.customStatuses.map(s => ({
        text: `Status: ${s.label}`,
        value: s.internalId,
        'data-testid': `status-${s.label}}`
      }));
    }
    setStatusesDD(newStatusesDD);

    if (!(data.condition.statusList && data.condition.statusList.length)) {
      // We should only get here if this is a new trigger.
      // Set default status (first status in the list)
      skipUpdate();
      dispatch({
        type: 'update_condition',
        payload: { statusList: [newStatusesDD[0].value] }
      });
    }
  }, [form]);

  const setInterval = useCallback(v => {
    let value = parseInt(v.target.value.replace(/[^\d.]+/g, ''));
    if (value < 0) {
      value = 0;
    }
    // if (value > 999) {
    //   value = 999;
    // }

    dispatch({ type: 'update_condition', payload: { interval: value } });
  }, []);

  const viewProps = {
    interval: data.condition.interval,
    intervalUnit: data.condition.intervalUnit,
    statusList: data.condition.statusList,
    statusesDD,
    setInterval,
    dispatch
  };

  return <StatusBasedSchedulerGeneratorView {...viewProps} />;
};

export default StatusBasedSchedulerGeneratorEngine;
